import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { LocationModule } from 'src/app/pipes/location/location.module';
import { AccountPhoneNumberRegisterComponent } from './account-phone-number-register/containers/account-phone-number-register.component';
import { AccountPhoneNumberRegisterViewComponent } from './account-phone-number-register/views/account-phone-number-register-view.component';
import { LocationPhoneNumberRegisterComponent } from './location-phone-number-register/containers/location-phone-number-register.component';
import { PhoneNumberRegisterEffects } from './state/phone-number-register.effects';
import { phoneNumberRegisterFeatureKey, phoneNumberRegisterReducer } from './state/phone-number-register.reducer';
import { SystemPhoneNumberRegisterComponent } from './system-phone-number-register/containers/system-phone-number-register.component';
import { SystemPhoneNumberRegisterViewComponent } from './system-phone-number-register/views/system-phone-number-register-view.component';

@NgModule({
   declarations: [
      SystemPhoneNumberRegisterViewComponent,
      SystemPhoneNumberRegisterComponent,
      AccountPhoneNumberRegisterComponent,
      AccountPhoneNumberRegisterViewComponent,
      LocationPhoneNumberRegisterComponent,
   ],
   imports: [
      CommonModule,
      FormsModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      MatButtonModule,
      MatInputModule,
      MatTooltipModule,
      MatIconModule,
      ReactiveFormsModule,
      RouterModule,
      ScrollingModule,
      RegisterModule,
      LocationModule,
      MatMenuModule,
      FormatPhoneNumbersPipeModule,
      EffectsModule.forFeature([PhoneNumberRegisterEffects]),
      StoreModule.forFeature(phoneNumberRegisterFeatureKey, phoneNumberRegisterReducer),
   ],
   exports: [
      SystemPhoneNumberRegisterComponent,
      AccountPhoneNumberRegisterComponent,
      LocationPhoneNumberRegisterComponent,
   ],
})
export class PhoneNumberRegisterModule {}
